(function (ws) {
    'use strict';

    ws.models.cartTableProduct = ws.models.outstandingStock.extend({

        defaults: {
            isCustomerInventory: null,
            isIntangible: null
        },

        idAttribute: 'id',

        /**
         * Override default sync() to append CSRF toke to requests
         * @param {string} method
         * @param {Object} model
         * @param {Object} options
         * @returns {*}
         */
        sync: function (method, model, options) {
            options = options || {};
            options.url = model.url();
            return Backbone.sync.apply(this, [method, model, options]);
        },

        /**
         * Parse api resposne
         * @param {Object} response
         * @returns {Object} response
         */
        parse: function (response) {
            response.isCustomerInventoryCount = this.hasCustomerStock(response.sapavailabilityList);
            response.futureAvailabilityCount = this.hasFutureAvailability(response.sapavailabilityList);
            response.maxAvailabilityRows = this.getMaxRowCount(response.sapavailabilityList);
            response.sapAvailabilityList = response.sapavailabilityList; //generic modal template property is capitalized

            //BE api to load and update return differently structured responses
            if (!response.id) {
                response.id = response.data[0].id;
            }

            response.partsNoUrl = encodeURIComponent(response.id);

            if (response.data) {
                response.data[0].cartTotal = response.cartTotal;
                return response.data[0];
            } else {
                return response;
            }
        }

    });
})(westcon);
